import {ConfigLoadGuard} from './guard/config-load-guard';
import {ExtraOptions, RouterModule, Routes} from '@angular/router';
import {ModuleWithProviders} from '@angular/core';
import {PlayerResolver} from './services/resolver/player.resolver';

export const appRoutes: Routes = [
    {
        path: 'unit-objective',
        loadComponent: () => import('./components/unit-objective/unit-objective.component'),
        canActivate: [ConfigLoadGuard],
        resolve: {player: PlayerResolver}
    },
    {
        path: 'popup-manager',
        loadComponent: () => import('./components/popup-manager/popup-manager.component'),
        outlet: 'popup',
        resolve: {player: PlayerResolver}
    },
    {
        path: 'settings-popup-manager',
        loadComponent: () => import('./components/popup-manager/popup-manager.component'),
        outlet: 'settings-popup',
        resolve: {player: PlayerResolver}
    },
    {
        path: 'alphabet-popup-manager',
        loadComponent: () => import('./components/popup-manager/popup-manager.component'),
        outlet: 'alphabet-popup',
        resolve: {player: PlayerResolver}
    },
    {
        path: 'help-popup-manager',
        loadComponent: () => import('./components/popup-manager/popup-manager.component'),
        outlet: 'help',
        resolve: {player: PlayerResolver}
    },
    {
        path: 'top-popup-manager',
        loadComponent: () => import('./components/popup-manager/popup-manager.component'),
        outlet: 'top-popup',
        resolve: {player: PlayerResolver}
    },
    {
        path: 'pdf',
        loadComponent: () => import('./views/pdf-view/pdf-view.component'),
        outlet: 'reference',
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'pdfassessment',
        loadComponent: () => import('./views/pdf-view/pdf-view.component'),
        outlet: 'pdfPopup',
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'explosion',
        loadComponent: () => import('./components/explosion/explosion.component'),
        outlet: 'aex'
    },
    {
        path: 'reference',
        loadComponent: () => import('./components/reference/reference.component'),
        outlet: 'reference'
    },
    {
        path: 'AlphabetExplosionModule',
        loadChildren: () => import('src/app/activities/AlphabetExplosion/AlphabetExplosion.module').then(m => m.AlphabetExplosionModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'AlphabetLearnletModule',
        loadChildren: () => import('src/app/activities/AlphabetLearnlet/AlphabetLearnlet.module').then(m => m.AlphabetLearnletModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'AlphabetRecognitionModule',
        loadChildren: () => import('src/app/activities/AlphabetRecognition/AlphabetRecognition.module')
            .then(m => m.AlphabetRecognitionModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'AlphexplorerModule',
        loadChildren: () => import('src/app/activities/Alphexplorer/Alphexplorer.module').then(m => m.AlphexplorerModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'AudioMultiChoiceModule',
        loadChildren: () => import('src/app/activities/AudioMultiChoice/AudioMultiChoice.module').then(m => m.AudioMultiChoiceModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'AudioPlayerModule',
        loadChildren: () => import('src/app/activities/AudioPlayer/AudioPlayer.module').then(m => m.AudioPlayerModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'ComeToThinkModule',
        loadChildren: () => import('src/app/activities/ComeToThink/ComeToThink.module').then(m => m.ComeToThinkModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'ConversationComprehensionModule',
        loadChildren: () => import('src/app/activities/ConversationComprehension/ConversationComprehension.module')
            .then(m => m.ConversationComprehensionModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'ConversationPreviewModule',
        loadChildren: () => import('src/app/activities/ConversationPreview/ConversationPreview.module')
            .then(m => m.ConversationPreviewModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'ConversationSayModule',
        loadChildren: () => import('src/app/activities/ConversationSay/ConversationSay.module').then(m => m.ConversationSayModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'CulturalAwarenessModule',
        loadChildren: () => import('src/app/activities/CulturalAwareness/CulturalAwareness.module').then(m => m.CulturalAwarenessModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'DialogueModule',
        loadChildren: () => import('src/app/activities/Dialogue/Dialogue.module').then(m => m.DialogueModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'DictationModule',
        loadChildren: () => import('src/app/activities/Dictation/Dictation.module').then(m => m.DictationModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'FourSquareProduceModule',
        loadChildren: () => import('src/app/activities/FourSquareProduce/FourSquareProduce.module').then(m => m.FourSquareProduceModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'GlossaryModule',
        loadChildren: () => import('src/app/activities/Glossary/Glossary.module').then(m => m.GlossaryModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'GrammarReferenceModule',
        loadChildren: () => import('src/app/activities/GrammarReference/GrammarReference.module').then(m => m.GrammarReferenceModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'HtmlPlayerModule',
        loadChildren: () => import('src/app/activities/HtmlPlayer/HtmlPlayer.module').then(m => m.HtmlPlayerModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'ImageComprehensionModule',
        loadChildren: () => import('src/app/activities/ImageComprehension/ImageComprehension.module').then(m => m.ImageComprehensionModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'ImageExplorerLocateItModule',
        loadChildren: () => import('src/app/activities/ImageExplorerLocateIt/ImageExplorerLocateIt.module')
            .then(m => m.ImageExplorerLocateItModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'ImageExplorerPreviewItModule',
        loadChildren: () => import('src/app/activities/ImageExplorerPreviewIt/ImageExplorerPreviewIt.module')
            .then(m => m.ImageExplorerPreviewItModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'ImageMatchingModule',
        loadChildren: () => import('src/app/activities/ImageMatching/ImageMatching.module').then(m => m.ImageMatchingModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'ImageMultipleChoiceModule',
        loadChildren: () => import('src/app/activities/ImageMultipleChoice/ImageMultipleChoice.module')
            .then(m => m.ImageMultipleChoiceModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'ImageRecognitionModule',
        loadChildren: () => import('src/app/activities/ImageRecognition/ImageRecognition.module').then(m => m.ImageRecognitionModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'ListeningComprehensionModule',
        loadChildren: () => import('src/app/activities/ListeningComprehension/ListeningComprehension.module')
            .then(m => m.ListeningComprehensionModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'ListeningRecognitionModule',
        loadChildren: () => import('src/app/activities/ListeningRecognition/ListeningRecognition.module')
            .then(m => m.ListeningRecognitionModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'LongMultipleChoiceModule',
        loadChildren: () => import('src/app/activities/LongMultipleChoice/LongMultipleChoice.module').then(m => m.LongMultipleChoiceModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'MatchingModule',
        loadChildren: () => import('src/app/activities/Matching/Matching.module').then(m => m.MatchingModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'MLNModule',
        loadChildren: () => import('src/app/activities/MLN/MLN.module').then(m => m.MLNModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'MultipleChoiceModule',
        loadChildren: () => import('src/app/activities/MultipleChoice/MultipleChoice.module').then(m => m.MultipleChoiceModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'PDFModule',
        loadChildren: () => import('src/app/activities/PDF/PDF.module').then(m => m.PDFModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'PlugnplayModule',
        loadChildren: () => import('src/app/activities/Plugnplay/Plugnplay.module').then(m => m.PlugnplayModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'PlugnplayWrittenModule',
        loadChildren: () => import('src/app/activities/PlugnplayWritten/PlugnplayWritten.module').then(m => m.PlugnplayWrittenModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'PowerSlidesModule',
        loadChildren: () => import('src/app/activities/PowerSlides/PowerSlides.module').then(m => m.PowerSlidesModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'PresentationModule',
        loadChildren: () => import('src/app/activities/Presentation/Presentation.module').then(m => m.PresentationModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'PreviewModule',
        loadChildren: () => import('src/app/activities/Preview/Preview.module').then(m => m.PreviewModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'ProduceSignModule',
        loadChildren: () => import('src/app/activities/ProduceSign/ProduceSign.module').then(m => m.ProduceSignModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'ProduceWrittenModule',
        loadChildren: () => import('src/app/activities/ProduceWritten/ProduceWritten.module').then(m => m.ProduceWrittenModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'PronunciationModule',
        loadChildren: () => import('src/app/activities/Pronunciation/Pronunciation.module').then(m => m.PronunciationModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'ReadingModule',
        loadChildren: () => import('src/app/activities/Reading/Reading.module').then(m => m.ReadingModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'RecognizeSignModule',
        loadChildren: () => import('src/app/activities/RecognizeSign/RecognizeSign.module').then(m => m.RecognizeSignModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'RecognizeWrittenModule',
        loadChildren: () => import('src/app/activities/RecognizeWritten/RecognizeWritten.module').then(m => m.RecognizeWrittenModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'SelfReportingProduceModule',
        loadChildren: () => import('src/app/activities/SelfReportingProduce/SelfReportingProduce.module')
            .then(m => m.SelfReportingProduceModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'SelfReportingRecognizeModule',
        loadChildren: () => import('src/app/activities/SelfReportingRecognize/SelfReportingRecognize.module')
            .then(m => m.SelfReportingRecognizeModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'SignMultipleChoiceModule',
        loadChildren: () => import('src/app/activities/SignMultipleChoice/SignMultipleChoice.module').then(m => m.SignMultipleChoiceModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'SignPreviewModule',
        loadChildren: () => import('src/app/activities/SignPreview/SignPreview.module').then(m => m.SignPreviewModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'SignRecognitionModule',
        loadChildren: () => import('src/app/activities/SignRecognition/SignRecognition.module').then(m => m.SignRecognitionModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'SignWrittenModule',
        loadChildren: () => import('src/app/activities/SignWritten/SignWritten.module').then(m => m.SignWrittenModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'SpellingInspectorModule',
        loadChildren: () => import('src/app/activities/SpellingInspector/SpellingInspector.module').then(m => m.SpellingInspectorModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'SpreadsheetModule',
        loadChildren: () => import('src/app/activities/Spreadsheet/Spreadsheet.module').then(m => m.SpreadsheetModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'SVOModule',
        loadChildren: () => import('src/app/activities/SVO/SVO.module').then(m => m.SVOModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'TableModule',
        loadChildren: () => import('src/app/activities/Table/Table.module').then(m => m.TableModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'TextTranslationModule',
        loadChildren: () => import('src/app/activities/TextTranslation/TextTranslation.module').then(m => m.TextTranslationModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'TranscribeItModule',
        loadChildren: () => import('src/app/activities/TranscribeIt/TranscribeIt.module').then(m => m.TranscribeItModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'TransformSayModule',
        loadChildren: () => import('src/app/activities/TransformSay/TransformSay.module').then(m => m.TransformSayModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'TransformWriteModule',
        loadChildren: () => import('src/app/activities/TransformWrite/TransformWrite.module').then(m => m.TransformWriteModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'TypingTutorModule',
        loadChildren: () => import('src/app/activities/TypingTutor/TypingTutor.module').then(m => m.TypingTutorModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'UnscrambleModule',
        loadChildren: () => import('src/app/activities/Unscramble/Unscramble.module').then(m => m.UnscrambleModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'VideoComprehensionModule',
        loadChildren: () => import('src/app/activities/VideoComprehension/VideoComprehension.module').then(m => m.VideoComprehensionModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'VideoImmersionModule',
        loadChildren: () => import('src/app/activities/VideoImmersion/VideoImmersion.module').then(m => m.VideoImmersionModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'VideoPlayerModule',
        loadChildren: () => import('src/app/activities/VideoPlayer/VideoPlayer.module').then(m => m.VideoPlayerModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'WebPageModule',
        loadChildren: () => import('src/app/activities/WebPage/WebPage.module').then(m => m.WebPageModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'WhatWouldYouSayModule',
        loadChildren: () => import('src/app/activities/WhatWouldYouSay/WhatWouldYouSay.module').then(m => m.WhatWouldYouSayModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'WICModule',
        loadChildren: () => import('src/app/activities/WIC/WIC.module').then(m => m.WICModule),
        canActivate: [ConfigLoadGuard]
    },
    {
        path: 'WordCloudModule',
        loadChildren: () => import('src/app/activities/WordCloud/WordCloud.module').then(m => m.WordCloudModule),
        canActivate: [ConfigLoadGuard]
    }
];

export function onRouterError(error: any): boolean {
    console.log(error);
    return false;
}
export const routerConfig: ExtraOptions = {
    initialNavigation: 'disabled',
    // enableTracing: true,
    errorHandler: onRouterError,
    onSameUrlNavigation: 'reload'
};

export const appRoutingProviders: any[] = [];
export const routing: ModuleWithProviders<RouterModule> = RouterModule.forRoot(appRoutes, routerConfig);
